import { Helmet } from 'react-helmet';
import VesselsDetail from 'src/features/VesselDetail';
import MainLayout from 'src/layouts';

const VesselDetailPage = () => {
  return (
    <MainLayout>
      <Helmet>
        <title>Vessels Detail</title>
      </Helmet>
      <VesselsDetail />
    </MainLayout>
  );
};

export default VesselDetailPage;
